import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Router } from "@angular/router";
import { BreadcrumService } from "@app/shared/services/breadcrum.service";
import { RolesSharedService } from '@app/feature/main/roles-shared/services/roles-shared.service';
import { ConnectMiniProfileComponent } from '@app/shared/components/connect-mini-profile/connect-mini-profile.component';
import { LikeModalServiceService } from './../../services/like-modal-service.service';
declare var $: any;
@Component({
  selector: 'app-likes',
  templateUrl: './likes.component.html',
  styleUrls: ['./likes.component.css']
})
export class LikesComponent implements OnInit {
  @Input('postData') public postData: any;
  @ViewChild(ConnectMiniProfileComponent) connectionMini: ConnectMiniProfileComponent;
  skip: number;
  limit: number;
  likeListArray: any = [];
  totalLikeCount: number;
  showMoreLikes: boolean;
  showNoDataMsg: boolean;
  showLessLikes: boolean;
  postId: string;

  constructor(
    public rolesSharedService: RolesSharedService,
    private router: Router,
    private breadcrumService: BreadcrumService,
    private likeModalService: LikeModalServiceService
  ) { }

  ngOnInit() {
    this.totalLikeCount = 0;
    this.skip = 0;
    this.limit = 5;
    if (this.postData) {
      if (this.postData.postType) {
        this.postId = this.postData.id;
      } else {
        this.postId = this.postData.id;
      }
      this.getLikesList(this.postId);
    }
  }

  getLikesList(postId: string) {
    this.showMoreLikes = false;
    this.rolesSharedService.getLikesData(postId, this.skip , this.limit).subscribe((responseData: any) => {
      if (responseData) {
        if (this.skip == 0) {
          this.likeListArray = responseData.data;
        } else {
          responseData.data.forEach(element => {
            this.likeListArray.push(element);
            this.scrollDown();
          });
        }
        this.totalLikeCount = responseData.totalCount;
        if (this.totalLikeCount > 0 && this.totalLikeCount > this.likeListArray.length) {
           this.showMoreLikes = true;
           this.showNoDataMsg = false;
           this.showLessLikes = false;
        } else if (this.totalLikeCount > this.limit && this.totalLikeCount == this.likeListArray.length){
          this.showMoreLikes = false;
          this.showNoDataMsg = false;
          this.showLessLikes = true;
        } else if (this.totalLikeCount == 0) {
          this.showMoreLikes = false;
          this.showNoDataMsg = true;
          this.showLessLikes = false;
        } else {
          this.showMoreLikes = false;
          this.showLessLikes = false;
        }
      }
    });
  }

  showMore() {
    this.skip = this.skip + 5;
    this.getLikesList(this.postId);
  }

  showLess() {
    this.skip = 0;
    this.getLikesList(this.postId);
  }

  routeTechAnalystProfilePageSide(user: any, analystId: string) {
    const name = user.firstName + ' ' + user.lastName;
    this.breadcrumService.setUrl('BC3Label', name);
    this.likeModalService.modalStatus(false, null);
    this.router.navigate(['analyst-profile'], { queryParams: { analystId: analystId } });
  }

  scrollDown() {

    $( document ).ready(function() {
      const elm = document.querySelectorAll('#likes-list');
      const last = elm[elm.length - 1];
      last.scrollIntoView({
        behavior: 'smooth',
        block: "end"
      });
    });

  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/likes/likes.component.ts